import Modal from 'services/modal';
import Http from 'services/http2';
import Util from 'lib/util';
import dayjs from 'dayjs';
import { BillType } from 'constants/custom-types';
const isEmpty = Util.isEmpty;
const isArray = Array.isArray;

/**
 * 自定义字段服务
 */
const CustFieldService = {
  isPurchase: true, //是否采购方
  billXkNo: undefined, //单号

  /**
   * 获取自定义字段设置
   *
   * @param companyCode 本公司编码
   * @param customerCode 客户公司编码（采购方调用接口时，此字段传 undefined）
   * @param isOnlyOpen  是否只获取已开启字段
   * @param billType  单据类型：22.送货单，51.询价, 52对账单, 16.交料通知, 64 付款单,19 请购单
   * @param supplierCategoryInfo 供应商分类信息
   * @param sourceSettingPage 是否来自设置页  0：否  1：是
   * @param fieldLevel 采购说明  4：单头采购说明  5：单身采购说明
   *
   * @returns //{ list, headCustList, bodyCustList, bodyNormalList, showBodyCol1, showBodyCol2, showBodyCol3, bodyShow, headShow }
   */
  async getSetting(
    companyCode: string | null,
    customerCode: string,
    isOnlyOpen: boolean = false,
    billType: string = '22',
    dispatch,
    supplierCategoryInfo?,
    sourceSettingPage?,
    fieldLevel?
  ) {
    if (companyCode === '0') {
      return;
    }
    let postbody = {
      billType,
      companyCode,
      customerCode,
      sourceSettingPage,
      fieldLevel,
      apiPath: '/b2bCompBillFieldDynamicConfig/list'
    };
    let rs;
    Modal.showLoading(dispatch);
    await Http.post('/api/cloudCenter', postbody).then(response => {
      Modal.hideLoading(dispatch);
      if (response.success) {
        /**
         * 配置列表，配置页保存用
         *
         * billType:   单据类型
         * fieldLevel: 0.单头，1.单身, 2.单身level2, 3.单身level3 送货单物料属性, 4.单头采购说明（预留）, 5.单身采购说明
         * fieldType:  0.标准，1.自定义
         * fieldMaxLength: 字段最大长度（校验用）
         * fieldCode:  字段编码
         * fieldName:  字段名
         * fieldValueType: 0.数值，1.文本，2.预设，3.日期, 4.上游单据, 6.基础资料
         * needVendorInputFlag: 是否需要供应商填写 0|1
         * openedFlag: 是否启用 0|1|2|3|4|5
         * fieldDynamicShowNameJson: 多语言字段名
         * presetValueJson 预设值
         *
         */
        let list = response.data || [];

        // 处理按供应商分类设置的启用和必填
        if (supplierCategoryInfo) {
          // 供应商分类类型与 supplierCategoryInfo 字段对应关系
          const cateMap = {
            '0001': 'categoryCode1',
            '0002': 'categoryCode2',
            '0003': 'categoryCode3',
            erp: 'erpCategoryCode'
          };
          list.forEach(item => {
            if (item.openedFlag === 2 && item.dynamicVendorCategoryDto) {
              item.openedFlag0 = 2; // 缓存是否启用原始值，方便被替换后查询原始值
              let categoryType = item.dynamicVendorCategoryDto.categoryType;
              let dynamicVendorCategoryList =
                item.dynamicVendorCategoryDto.dynamicVendorCategoryList || [];
              let categoryCode = supplierCategoryInfo[cateMap[categoryType]];
              dynamicVendorCategoryList.forEach(row => {
                if (row.categoryCode === categoryCode) {
                  // 如果按供应商分类有设置，复制到父级
                  item.openedFlag = row.openedFlag;
                  item.isRequiredField = row.isRequiredField;
                }
              });
            }
          });
        }

        //单身字段列是否显示
        let showBodyCol = false;
        let showBodyCol1 = false;
        let showBodyCol2 = false;
        let showBodyCol3 = false;
        let showBodyCol4 = false;

        // 是否显示物料属性
        let showLevel3 = false;

        //是否显示单头|单身字段
        let showHead = false;
        let showBody = false;

        //单身字段是否显示
        let bodyShow = {};

        //单头字段是否显示
        let headShow = {};

        if (isOnlyOpen) {
          // 1.双方 2.按供应商 3.采购方 4.按物料 5.按物料分类
          list = list.filter(
            item =>
              [1, 2, 4, 5].includes(item.openedFlag) ||
              (!customerCode && item.openedFlag === 3)
          );
        }

        //自定义字段语言使用的下划线，此处需要转换
        let lang = 'zh_Hans';
        list.forEach(item => {
          item.json = Util.jsonDecode(item.fieldDynamicShowNameJson) || {};
          item.transName = item.json[lang] || item.json['zh_Hans'];
          if (item.fieldLevel === 1) {
            bodyShow[item.fieldCode] = true;
          } else if (item.fieldLevel === 0 && item.fieldType === 1) {
            headShow[item.fieldCode] = true;
          }
          item.presetValue = !Util.isEmpty(item.presetValueJson)
            ? Util.jsonDecode(item.presetValueJson)
            : [];

          //详情页预设值下拉选单数据
          if (isArray(item.presetValue)) {
            item.presetValueList = item.presetValue.map(row => {
              // 旧数据容错, 上线两周后删除
              if (typeof row === 'string') {
                return { id: row, text: row };
              }
              return {
                id: row.value,
                text: row.value,
                isDefault: row.isDefault
              };
            });
          }

          // 校验规则Json转数组
          item.validateRules = !Util.isEmpty(item.validateRules)
            ? Util.jsonDecode(item.validateRules)
            : [];

          //日期类型代理字段名。如 extendN01 对应 extendN01Date
          if (item.fieldValueType === 3) {
            item.extendDate = item.fieldCode + 'Date';
          }
        });

        let headCustList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 0
        );
        let bodyCustList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 1
        );
        let level2CustList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 2
        );
        let level3CustList = list.filter(item => item.fieldLevel === 3);
        let headNormalList = list.filter(
          item => item.fieldType === 0 && item.fieldLevel === 0
        );
        let bodyNormalList = list.filter(
          item => item.fieldType === 0 && item.fieldLevel === 1
        );
        let headExtendList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 4
        );
        let bodyExtendList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 5
        );
        showHead = headCustList.length > 0;
        showBody = bodyCustList.length > 0;

        //单身自定义列（将废弃，请使用 showBody）
        showBodyCol = bodyCustList.length > 0;

        let arrField = list.map(item => item.fieldCode);

        //单身自定义列（将废弃，请使用 showBody）
        showBodyCol3 = bodyCustList.length > 0;

        /**
         *  送货通知 单身显示字段
         *  开启后, 采购方只可查看，供应商只可编辑
         *
         */
        if (billType === '22') {
          //毛重 净重 重量单位 批号 生产日期
          showBodyCol1 = [
            'grossWeight',
            'netWeight',
            'unitWeightName',
            'batchNumber',
            'productionDate'
          ].some(field => arrField.includes(field));
          //包装数 品牌 原产地1 长 宽 高
          showBodyCol2 = [
            'packingQty',
            'brandName',
            'originalCountryName',
            'prodLength',
            'prodHeight',
            'prodWidth'
          ].some(field => arrField.includes(field));
          // 长 宽 高
          // showBodyCol4 = ['prodLength', 'prodHeight', 'prodWidth'].some(field => arrField.includes(field));
          //单身显示字段增加翻译字段
          const map = {
            grossWeight: { transKey: 'BASE.GROSS_WEIGHT', order: 1 },
            netWeight: { transKey: 'BASE.NET_WEIGHT', order: 2 },
            unitWeightName: { transKey: 'BASE.UNIT_OF_WEIGHT', order: 3 },
            packingQty: { transKey: 'DELIVERY.PACKAGE_COUNT', order: 4 },
            brandName: { transKey: 'BASE.BRAND', order: 5 },
            originalCountryName: {
              transKey: 'BASE.COUNTRY_OF_ORIGIN',
              order: 6
            },
            otherExtend: { transKey: 'BASE.DESCRIPTION', order: 7 },
            prodLength: { transKey: 'BASE.LENGTH_CM', order: 8 },
            prodWidth: { transKey: 'BASE.WIDTH_CM', order: 9 },
            prodHeight: { transKey: 'BASE.HEIGHT_CM', order: 10 },
            batchNumber: { transKey: 'BASE.LOT_NO', order: 11 },
            productionDate: { transKey: 'BASE.PRODUCTION_DATE', order: 12 }
          };
          bodyNormalList.forEach(item => {
            item.transKey = map[item.fieldCode]?.transKey;
            item.order = map[item.fieldCode]?.order;
          });
          //按显示排序
          bodyNormalList.sort(function (a, b) {
            return a.order - b.order;
          });

          // 物料属性增加翻译字段
          level3CustList.forEach(item => {
            const map2 = {
              unitNetWeight: { transKey: 'BASE.UNIT_NET_WEIGHT' }
            };
            item.transKey = map2[item.fieldCode]?.transKey;
          });
          showLevel3 =
            level3CustList.filter(item => item.openedFlag === 1).length > 0;
        }

        rs = {
          companyCode,
          customerCode,
          billType,
          list,
          headCustList, //单头自定义字段列表
          bodyCustList, //单身自定义字段列表
          headNormalList, //单头标准字段列表
          bodyNormalList, //单身标准字段列表
          level2CustList, // 单身level2自定义字段，如采购单预订单自定义字段
          level3CustList, // 单身level3自定义字段，包含标准和自定义字段。如送货单物料属性
          headExtendList, //单头采购说明列表
          bodyExtendList, //单身采购说明列表
          showHead,
          showBody,
          showBodyCol,
          showBodyCol1,
          showBodyCol2,
          showBodyCol3, //单身自定义字段列
          showBodyCol4,
          showLevel3,
          bodyShow,
          headShow
        };
      } else {
        //仅在设置页显示错误信息
        if (!isOnlyOpen) {
          Modal.showError(response.errorMsg, dispatch);
        }
      }
    });
    return rs;
  },

  /**
   * 获取上游单据字段配置
   *
   * @param companyCode
   * @param customerCode
   * @param billType
   * @returns
   */
  async getSourceBillSetting(
    companyCode: string | null,
    customerCode: string,
    billType: BillType
  ) {
    if (companyCode === '0') {
      return;
    }
    let postbody = {
      billType,
      companyCode,
      customerCode,
      apiPath: '/b2bCompBillFieldDynamicConfig/list'
    };
    let list;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        list = response.data || [];
      }
    });
    return list;
  },

  /**
   * 可编辑上游单据字段转换为普通字段，以便编辑时保持类型一致
   * @param companyCode
   * @param customerCode
   * @param fieldSetting
   * @returns
   */
  async transformSourceField(
    companyCode: string | null,
    customerCode: string,
    fieldSetting
  ) {
    let cache = {}; //缓存

    //上游单据且开启编辑
    let list = fieldSetting?.list?.filter(
      item => item.fieldValueType === 4 && item.editFlag === 1
    );

    //递归获取上游单据字段
    let getSourceField = async (
      sourceBillType,
      sourceFieldCode,
      sourceFieldLevel
    ) => {
      let sourceFieldList;
      if (isEmpty(cache[sourceBillType])) {
        sourceFieldList = await this.getSourceBillSetting(
          companyCode,
          customerCode,
          sourceBillType
        );
        cache[sourceBillType] = sourceFieldList;
      } else {
        sourceFieldList = cache[sourceBillType];
      }
      let sourceField = sourceFieldList.filter(
        field =>
          field.fieldLevel === sourceFieldLevel &&
          field.fieldCode === sourceFieldCode
      )[0];

      if (sourceField?.fieldValueType === 4) {
        return await getSourceField(
          sourceField.sourceBillType,
          sourceField.sourceFieldCode,
          sourceField.sourceFieldLevel
        );
      } else {
        return sourceField;
      }
    };

    if (isEmpty(list)) {
      return;
    }
    for (let item of list) {
      item.fieldValueTypeOld = item.fieldValueType; //缓存初始值
      const { sourceBillType, sourceFieldCode, sourceFieldLevel } = item;
      if (isEmpty(sourceBillType, sourceFieldCode, sourceFieldLevel)) {
        continue;
      }
      let sourceField = await getSourceField(
        sourceBillType,
        sourceFieldCode,
        sourceFieldLevel
      );
      if (sourceField && sourceField.fieldValueType !== 4) {
        item.fieldValueType = sourceField.fieldValueType;
        item.presetValueJson = sourceField.presetValueJson;
        //详情页预设值下拉选单数据
        item.presetValue = !Util.isEmpty(item.presetValueJson)
          ? Util.jsonDecode(item.presetValueJson)
          : [];
        item.presetValueList = item.presetValue.map(row => {
          // 旧数据容错, 上线两周后删除
          if (typeof row === 'string') {
            return { id: row, text: row };
          }
          return {
            id: row.value,
            text: row.value,
            isDefault: row.isDefault
          };
        });
        //日期类型代理字段名。如 extendN01 对应 extendN01Date
        if (item.fieldValueType === 3) {
          item.extendDate = item.fieldCode + 'Date';
        }
      }
    }
  },

  /**
   * 校验自定义字段
   *
   * @param detail 单据详情数据
   * @param lineList 单身数据
   * @param fieldSetting
   * @param [isPurchase] 是否采购方
   * @param opt 额外参数
   * @returns
   */
  validate(
    detail,
    lineList,
    fieldSetting,
    isPurchase = false,
    dispatch,
    opt: any = {}
  ) {
    let headCustList = fieldSetting.headCustList || [];
    let bodyCustList = fieldSetting.bodyCustList || [];
    let bodyNormalList = fieldSetting.bodyNormalList || [];
    // 显示必填错误信息
    let showLengthError = (field, length) => {
      Modal.showError(field + '长度不能超过' + length, dispatch);
    };
    // 显示必填错误信息
    let showEmptyError = content => {
      Modal.showError(content + '不能为空', dispatch);
    };

    /**
     * 校验用户自定义规则
     *
     * @param item        单头或单身
     * @param row         自定义字段配置项
     * @param isPurchase  是否采购方
     */
    let validateRules = (item, row) => {
      /**
       * 1.本方可编辑字段, 或可编辑的单身显示字段
       * 2.字段类型是数字或文本
       * 3.有设置规则
       */
      if (
        ((isPurchase ? row.editFlag === 1 : row.needVendorInputFlag === 1) ||
          (row.editFlag === 1 && row.fieldType === 0)) &&
        [0, 1].includes(row.fieldValueType) &&
        row.validateRules?.length > 0
      ) {
        let value = item[row.fieldCode];
        for (let rule of row.validateRules) {
          let { pattern, errorMsg } = rule;
          pattern = pattern.replaceAll('/', '');
          let re = new RegExp(pattern);
          if (typeof value === 'string' && !re.test(value)) {
            Modal.showError(
              (row.transName || row.fieldName) + '：' + errorMsg,
              dispatch
            );
            return false;
          }
        }
      }
      return true;
    };

    /**
     * 校验字段最大位数&数据库最大长度
     *
     * @param item        单头或单身
     * @param row         自定义字段配置项
     * @param isPurchase  是否采购方
     */
    let validateLengh = (item, row) => {
      /**
       * 1.本方可编辑字段, 或可编辑的单身显示字段
       * 2.字段类型是数字或文本
       */
      if (
        ((isPurchase ? row.editFlag === 1 : row.needVendorInputFlag === 1) ||
          (row.editFlag === 1 && row.fieldType === 0)) &&
        [0, 1].includes(row.fieldValueType)
      ) {
        let value = item[row.fieldCode];

        // 校验用户设置的最大位数
        if (
          typeof row.fieldMaxLength === 'number' &&
          typeof value === 'string' &&
          value.length > row.fieldMaxLength
        ) {
          showLengthError(row.transName || row.fieldName, row.fieldMaxLength);
          return false;
        }

        // 校验数据库字段最大长度
        if (
          typeof row.dbFieldMaxLength === 'number' &&
          typeof value === 'string' &&
          value.length > row.dbFieldMaxLength
        ) {
          showLengthError(row.transName || row.fieldName, row.dbFieldMaxLength);
          return false;
        }
      }
      return true;
    };

    if (detail) {
      let i = 0;
      for (let row of headCustList) {
        // 单头自定义字段不能为空
        if (
          (isPurchase ? row.editFlag === 1 : row.needVendorInputFlag === 1) &&
          row.isRequiredField === 1
        ) {
          if (row.fieldValueType === 2) {
            if (
              isEmpty(detail[headCustList[i].fieldCode]) &&
              !isEmpty(row.presetValueList)
            ) {
              showEmptyError(row.transName);
              return false;
            }
          } else if (row.fieldValueType === 3) {
            if (isEmpty(detail[row.extendDate])) {
              showEmptyError(row.transName);
              return false;
            }
          } else {
            if (isEmpty(detail[headCustList[i].fieldCode])) {
              showEmptyError(row.transName);
              return false;
            }
          }
        }

        // 校验单头字段长度
        if (!validateLengh(detail, row)) {
          return false;
        }

        // 校验用户自定义规则
        if (!validateRules(detail, row)) {
          return false;
        }

        i += 1;
      }
    }

    if (isArray(lineList) && lineList.length > 0) {
      //单身自定义字段不能为空
      for (let line of lineList) {
        if (isArray(line)) {
          for (let item of line) {
            for (let row of bodyCustList) {
              if (
                (isPurchase
                  ? row.editFlag === 1
                  : row.needVendorInputFlag === 1) &&
                row.isRequiredField === 1
              ) {
                if (row.fieldValueType === 2) {
                  if (
                    isEmpty(item[row.fieldCode]) &&
                    !isEmpty(row.presetValueList)
                  ) {
                    showEmptyError(row.transName);
                    return false;
                  }
                } else if (row.fieldValueType === 3) {
                  if (isEmpty(item[row.extendDate])) {
                    showEmptyError(row.transName);
                    return false;
                  }
                } else {
                  if (isEmpty(item[row.fieldCode])) {
                    showEmptyError(row.transName);
                    return false;
                  }
                }
              }
            }
          }
        } else {
          let item = line;
          for (let row of bodyCustList) {
            if (
              (isPurchase
                ? row.editFlag === 1
                : row.needVendorInputFlag === 1) &&
              ((!item.objRequired && row.isRequiredField === 1) ||
                (item.objOpen &&
                  item.objOpen[row.fieldCode] &&
                  item.objRequired &&
                  item.objRequired[row.fieldCode]))
            ) {
              if (row.fieldValueType === 2) {
                if (
                  isEmpty(item[row.fieldCode]) &&
                  !isEmpty(row.presetValueList)
                ) {
                  showEmptyError(row.transName);
                  return false;
                }
              } else if (row.fieldValueType === 3) {
                if (isEmpty(item[row.extendDate])) {
                  showEmptyError(row.transName);
                  return false;
                }
              } else {
                if (isEmpty(item[row.fieldCode])) {
                  showEmptyError(row.transName);
                  return false;
                }
              }
            }
          }
        }
      }

      //预订单自定义字段
      if (
        detail &&
        detail.isAdvanceOrder === 1 &&
        !this.valiLevel2CustDate(
          lineList,
          fieldSetting,
          isPurchase,
          [],
          dispatch
        )
      ) {
        return false;
      }

      //送货单，单身显示字段不能为空, 净重不大于毛重
      if (fieldSetting.billType === '22' && !isPurchase) {
        // 是否净重,毛重都开启
        let isCheckWeight =
          bodyNormalList.filter(item =>
            ['grossWeight', 'netWeight'].includes(item.fieldCode)
          ).length === 2;
        // 净重不能大于毛重
        let checkWeight = item => {
          if (
            isCheckWeight &&
            !isEmpty(item['netWeight'], item['grossWeight']) &&
            parseFloat(item['netWeight']) > parseFloat(item['grossWeight'])
          ) {
            Modal.showError('净重不能大于毛重', dispatch);
            return false;
          }
          return true;
        };

        for (let line of lineList) {
          if (isArray(line)) {
            for (let item of line) {
              for (let row of bodyNormalList) {
                // 必填且开启
                if (
                  (row.isRequiredField === 1 ||
                    item.objRequired[row.fieldCode]) &&
                  item.objOpen[row.fieldCode]
                ) {
                  let value = item[row.fieldCode];
                  if (row.fieldCode === 'productionDate') {
                    value = item['productionDateTs'];
                  }
                  if (isEmpty(value)) {
                    showEmptyError(row.fieldName);
                    return false;
                  }
                }
                // 校验字段最大长度
                if (!validateLengh(item, row)) {
                  return false;
                }
                // 校验用户自定义规则
                if (!validateRules(item, row)) {
                  return false;
                }
              }

              // 净重不能大于毛重
              if (!checkWeight(item)) {
                return;
              }
            }
          } else {
            let item = line;

            for (let row of bodyNormalList) {
              // 必填且开启
              if (
                (row.isRequiredField === 1 ||
                  item.objRequired[row.fieldCode]) &&
                item.objOpen[row.fieldCode]
              ) {
                let value = item[row.fieldCode];
                if (row.fieldCode === 'productionDate') {
                  value = item['productionDateTs'];
                }
                if (isEmpty(value)) {
                  showEmptyError(row.fieldName);
                  return false;
                }
              }
              // 校验字段最大长度
              if (!validateLengh(item, row)) {
                return false;
              }
              // 校验用户自定义规则
              if (!validateRules(item, row)) {
                return false;
              }
            }

            // 净重不能大于毛重
            if (!checkWeight(item)) {
              return;
            }
          }
        }
      }

      for (let line of lineList) {
        if (isArray(line)) {
          for (let item of line) {
            for (let row of bodyCustList) {
              // 校验单身自定义字段长度
              if (!validateLengh(item, row)) {
                return false;
              }
              // 校验用户自定义规则
              if (!validateRules(item, row)) {
                return false;
              }
            }
          }
        } else {
          let item = line;
          for (let row of bodyCustList) {
            // 校验单身自定义字段长度
            if (!validateLengh(item, row)) {
              return false;
            }
            // 校验用户自定义规则
            if (!validateRules(item, row)) {
              return false;
            }
          }
        }
      }
    }

    return true;
  },

  /**
   * 校验预订单自定义字段
   *
   * @param lineList 单身数据
   * @param excludeCustFields 不校验的项（采购单有25个预订单自定义字段，变更单、延迟送货申请有些字段没有，需过滤掉不校验）
   *
   * @returns
   */
  valiLevel2CustDate(
    lineList,
    fieldSetting,
    isPurchase = false,
    excludeCustFields: string[] = [],
    dispatch
  ) {
    let level2CustList = fieldSetting.level2CustList || [];
    let showError = content => {
      Modal.showError(content + '不能为空', dispatch);
    };

    if (isArray(lineList) && lineList.length > 0) {
      //预订单自定义字段
      if (
        fieldSetting.billType === '10' &&
        !isPurchase &&
        !Util.isEmpty(level2CustList)
      ) {
        for (let line of lineList) {
          if (isArray(line)) {
            for (let item of line) {
              for (let row of level2CustList) {
                if (
                  (isPurchase
                    ? row.editFlag === 1
                    : row.needVendorInputFlag === 1) &&
                  row.isRequiredField === 1 &&
                  item.lineAsset &&
                  !excludeCustFields.includes(row.fieldCode)
                ) {
                  if (row.fieldValueType === 2) {
                    if (
                      isEmpty(item.lineAsset[row.fieldCode]) &&
                      !isEmpty(row.presetValueList)
                    ) {
                      showError(row.transName);
                      return false;
                    }
                  } else if (row.fieldValueType === 3) {
                    if (isEmpty(item.lineAsset[row.extendDate])) {
                      showError(row.transName);
                      return false;
                    }
                  } else {
                    if (isEmpty(item.lineAsset[row.fieldCode])) {
                      showError(row.transName);
                      return false;
                    }
                  }
                }
              }
            }
          } else {
            let item = line;
            for (let row of level2CustList) {
              if (
                (isPurchase
                  ? row.editFlag === 1
                  : row.needVendorInputFlag === 1) &&
                row.isRequiredField === 1 &&
                item.lineAsset &&
                !excludeCustFields.includes(row.fieldCode)
              ) {
                if (row.fieldValueType === 2) {
                  if (
                    isEmpty(item.lineAsset[row.fieldCode]) &&
                    !isEmpty(row.presetValueList)
                  ) {
                    showError(row.transName);
                    return false;
                  }
                } else if (row.fieldValueType === 3) {
                  if (isEmpty(item.lineAsset[row.extendDate])) {
                    showError(row.transName);
                    return false;
                  }
                } else {
                  if (isEmpty(item.lineAsset[row.fieldCode])) {
                    showError(row.transName);
                    return false;
                  }
                }
              }
            }
          }
        }
      }
    }

    return true;
  },

  /**
   * 处理单头单身自定义字段（日期）
   *
   * @param fieldSetting
   * @param detail
   * @param list
   * @param isPurchase
   */
  parseCustFields(fieldSetting, detail, list, isPurchase) {
    //校验YYYY-MM-DD，是否合法
    let dateReg =
      /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/;
    fieldSetting.list
      .filter(field => field.fieldType === 1)
      .forEach(field => {
        if (
          field.fieldValueType === 3 &&
          field.needVendorInputFlag === (isPurchase ? 0 : 1)
        ) {
          if (field.fieldLevel === 0 && dateReg.test(detail[field.fieldCode])) {
            //单头自定义
            detail[field.extendDate] = dayjs(detail[field.fieldCode]).valueOf();
          } else if (field.fieldLevel === 1 && list) {
            //单身自定义
            list.forEach(line => {
              if (isArray(line)) {
                line.forEach(item => {
                  if (dateReg.test(item[field.fieldCode])) {
                    item[field.extendDate] = dayjs(
                      item[field.fieldCode]
                    ).valueOf();
                  }
                });
              } else {
                if (dateReg.test(line[field.fieldCode])) {
                  line[field.extendDate] = dayjs(
                    line[field.fieldCode]
                  ).valueOf();
                }
              }
            });
          }
        }
      });
  },

  /**
   * 获取自定义字段 预设值
   *
   * @param data 自定义配置数据
   * @param detail 单据详情数据
   *例如 extendN01 的预设值， 保存为extendN01List
   * @returns
   */
  getExtendValue(data, detail) {
    let fieldCodeList: any = { head: [], body: [] }; //全部自定义字段名
    // 数据处理，预设转换为list，并赋值在配置数据中
    // 单头数据配置
    if (Array.isArray(data.headCustList)) {
      data.headCustList.forEach(item => {
        fieldCodeList.head.push(item.fieldCode);
        let o = Util.jsonDecode(item.presetValueJson);
        if (!Util.isEmpty(o)) {
          item[item.fieldCode + 'List'] = o.map(row => {
            // 旧数据容错, 上线两周后删除
            if (typeof row === 'string') {
              return { id: row, text: row };
            }
            return {
              id: row.value,
              text: row.value,
              isDefault: row.isDefault
            };
          });
        }
      });
    }

    // 单头赋值
    if (Array.isArray(data.headCustList)) {
      data.headCustList.forEach(item => {
        if (Array.isArray(detail.lineList)) {
          fieldCodeList.head.forEach(head => {
            if (item.fieldCode === head) {
              detail[head + 'List'] = item[head + 'List'];
            }
          });
        }
      });
    }
    // 单身数据配置
    if (Array.isArray(data.bodyCustList)) {
      data.bodyCustList.forEach(item => {
        fieldCodeList.body.push(item.fieldCode);
        let o = Util.jsonDecode(item.presetValueJson);
        if (!Util.isEmpty(o)) {
          item[item.fieldCode + 'List'] = o.map(row => {
            // 旧数据容错, 上线两周后删除
            if (typeof row === 'string') {
              return { id: row, text: row };
            }
            return {
              id: row.value,
              text: row.value,
              isDefault: row.isDefault
            };
          });
        }
      });
    }
    // 单身赋值
    if (Array.isArray(data.bodyCustList)) {
      data.bodyCustList.forEach(item => {
        if (Array.isArray(detail.lineList)) {
          fieldCodeList.body.forEach(body => {
            detail.lineList.forEach(val => {
              if (item.fieldCode === body) {
                val[body + 'List'] = item[body + 'List'];
              }
            });
          });
        }
      });
    }
  },

  /**
   * 获取单头自定义字段提交数据
   * @param fieldSetting
   * @param detail
   * @param isPurchase
   * @returns
   */
  getHeadData(fieldSetting, detail, isPurchase) {
    let headData = {};
    fieldSetting.headCustList?.forEach(field => {
      if (isPurchase ? field.editFlag === 1 : field.needVendorInputFlag === 1) {
        headData[field.fieldCode] = detail[field.fieldCode];
      }
    });
    return headData;
  },

  /**
   * 获取单身自定义字段提交数据
   * @param fieldSetting
   * @param item
   * @param isPurchase
   * @returns
   */
  getBodyData(fieldSetting, item, isPurchase) {
    let bodyData = {};
    fieldSetting.bodyCustList?.forEach(field => {
      if (field.needVendorInputFlag === (isPurchase ? 0 : 1)) {
        bodyData[field.fieldCode] = item[field.fieldCode];
      }
    });
    return bodyData;
  },

  /**
   * 计算送货单单身显示字段是否开启，是否必填
   *
   * 1. 批号，生产日期可以设置成按物料开启
   * 2. 按物料开启时，需要查物料档案中这两个字段的开启标识
   *    "expirationDateFlag"  质保期管理，对应显示字段 productionDate
        "batchNumberFlag":    批号管理，  对应显示字段 batchNumber
   *
   * @param companyCode  启用编码
   * @param lineList     单身列表
   * @param fieldSetting 自定义字段配置
   */
  async checkBodyNormalFieldOpen(companyCode, lineList, fieldSetting) {
    let objOpen = {}; // 是否开启
    let objReqired = {}; // 是否必填
    let arrProdFieldCode: any[] = []; // 按物料开启的自定义字段列表
    let prodCodeList: any[] = []; // 物料编码列表

    fieldSetting.bodyNormalList?.forEach(field => {
      let { fieldCode, openedFlag, isRequiredField } = field;
      // 是否开启
      if (openedFlag === 1) {
        objOpen[fieldCode] = true;
      } else if (openedFlag === 4) {
        // 按物料
        objOpen[fieldCode] = false;
        arrProdFieldCode.push(fieldCode);
      }
      // 是否必填
      if (isRequiredField === 1) {
        objReqired[fieldCode] = true;
      }
    });

    // 把自定义字段是否启用标识写入列表项
    lineList.forEach(line => {
      prodCodeList.push(line[0].productCode);
      line.forEach(item => {
        // 切断引用
        item.objOpen = Object.assign({}, objOpen);
        item.objReqired = Object.assign({}, objReqired);
      });
    });

    // 处理按物料开启
    if (arrProdFieldCode.length > 0) {
      let arrProdInfo;
      // 获取物料档案配置
      let postbody = {
        companyCode,
        prodCodeList,
        apiPath: '/archives/compProd/getProdFieldInfosList'
      };
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          arrProdInfo = response.data;
        }
      });
      if (Array.isArray(arrProdInfo)) {
        arrProdInfo.forEach(prodInfo => {
          let { productCode, expirationDateFlag, batchNumberFlag } = prodInfo;
          if (expirationDateFlag === 1 || batchNumberFlag === 1) {
            lineList.forEach(line => {
              line.forEach(item => {
                if (item.productCode === productCode) {
                  item.objOpen.productionDate = expirationDateFlag === 1;
                  item.objOpen.batchNumber = batchNumberFlag === 1;
                }
              });
            });
          }
        });
      }
    }
  }
};

export default CustFieldService;
